export enum AssetReleaseState {
  Pending = 0,
  Complete = 1,
  Failed = -1
}
